import React from 'react';
import FitGate from './FitGate';
import type { FitAction } from './types';

interface Props {
  actions: FitAction[];
  entitled: boolean;
  onUnlock: () => void;
}

const FitActions: React.FC<Props> = ({ actions, entitled, onUnlock }) => {
  if (actions.length === 0) {
    return (
      <div className="fr-allclear">
        Nothing to change. Every measurement we can act on is already inside its ideal
        range — keep riding it.
      </div>
    );
  }

  return (
    <div>
      {actions.map((action, i) => (
        <article key={`${action.kind}-${action.index}-${i}`}
          className={`fr-act${action.kind === 'hold' ? ' fr-act--hold' : ''}`}>
          <div className="fr-act__head">
            <span className="fr-act__idx">{action.index}</span>
            <h3 className="fr-act__title">{action.title}</h3>
          </div>

          <div className="fr-tags">
            <span className="fr-tag">Change <b>{action.tags.change}</b></span>
            <span className="fr-tag">Confidence <b>{action.tags.confidence}</b></span>
            <span className="fr-tag">Takes <b>{action.tags.time}</b></span>
          </div>

          {entitled ? (
            <>
              {action.why && <p className="fr-act__body">{action.why}</p>}

              {action.how_steps && action.how_steps.length > 0 && (
                <details className="fr-how">
                  <summary>How to do it</summary>
                  <ol>
                    {action.how_steps.map((step, s) => <li key={s}>{step}</li>)}
                  </ol>
                </details>
              )}

              {action.expect && (
                <div className="fr-note"><b>What to expect:</b> {action.expect}</div>
              )}
              {action.caveat && (
                <div className="fr-note"><b>Worth knowing:</b> {action.caveat}</div>
              )}
            </>
          ) : (
            <FitGate
              variant={i === 0 ? 'card' : 'mini'}
              onUnlock={onUnlock}
              message={
                action.kind === 'hold'
                  ? "Why we're leaving this alone — in the full plan."
                  : `Change ${action.index} of ${
                      actions.filter((a) => a.kind === 'change').length
                    } — the reasoning and the steps come with the full plan.`
              }
            />
          )}
        </article>
      ))}
    </div>
  );
};

export default FitActions;
